import React, { Component, } from 'react';
import { Link } from "react-router-dom";
import {
    Button,
    Col,
    Row
} from 'antd';
import registerLogo from './images/header-logo.png';

let baseUrl = window.location.origin
class Header extends Component {
    render() {
        if (window.location.host.includes("localhost") || window.location.host.includes("beta") || window.location.host.includes("bfiledev")) {
            baseUrl = "https://beta.bfilesystem.com"
        }
        return (
            <React.Fragment>
                <Row gutter={16}>
                    <Col md={8} span={24}>
                        <img width={150} src={registerLogo} alt="B File" />
                    </Col>
                    <Col xs={24} md={8}  className='left-link-register'>
                        <Button type="link" href={`${baseUrl}/the-system/`} target="blank">THE SYSTEM</Button>
                        <Button type="link" href={`${baseUrl}/pricing/`} target="blank">PRICING</Button>
                        <Button type="link" href={`${baseUrl}/about-us/`} target="blank">ABOUT US</Button>
                    </Col>
                    <Col xs={24} md={8} className='right-link-register'>
                        <Button className="demo-button" href="https://meetings.hubspot.com/bfile/b-file-team-demo" target="blank">BOOK A DEMO</Button>
                        <Button type="link" href={`${baseUrl}/app/#/login`} target="blank"><span style={{ color: "#43ade2", textDecoration: "underline" }}>LOGIN</span></Button>
                        <Button type="link" disabled><span style={{ color: "white", textDecoration: "underline" }}>SIGN UP</span></Button>
                    </Col >
                </Row >
                <Row>
                    <h1>Register</h1>
                </Row>
            </React.Fragment >
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/scenes/Register/parts/header.js